import React, { useState } from 'react';
import { arrayOf, number, oneOfType, shape, string } from 'prop-types';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';
import { CollapseIcon, ExpandIcon } from 'components/Icon';

/* eslint-disable css-modules/no-undef-class */
import styles from './Accordion.scss';

export default function Accordion({ items, defaultActiveKey }) {
  useStyles(styles);

  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  const handleClickItem = key => () =>
    setActiveKey(activeKey === key ? undefined : key);

  const renderItem = ({ title, content, key }) => (
    <div
      key={key}
      className={cx(styles.item, { [styles.active]: activeKey === key })}
      onClick={handleClickItem(key)}
    >
      <div className={styles.header}>
        <span className={styles.label}>{title}</span>
        <CollapseIcon className={styles.collapseIcon} />
        <ExpandIcon className={styles.expandIcon} />
      </div>
      <div className={styles.content}>{content}</div>
    </div>
  );

  return <div className={styles.root}>{items.map(renderItem)}</div>;
}

Accordion.propTypes = {
  items: arrayOf(
    shape({
      title: string.isRequired,
      content: string.isRequired,
      key: oneOfType([string, number]).isRequired,
    }),
  ).isRequired,
  defaultActiveKey: oneOfType([string, number]),
};

Accordion.defaultProps = {
  defaultActiveKey: undefined,
};
